<header class="site-header">
  <div class="site-logo onstart animated" data-animation="fadeInDown" data-animation-delay="1200" style="text-align: center;">
    <!--<img src="images/logo.png" alt="" />-->
    <h3> <strong>LÍNEA DE TAXI AEROPUERTO EXPRESS</strong> </h3>
  </div>
</header>
